var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col space-x-2" };
const _hoisted_2 = { class: "text-lg text-gray-900 font-semibold" };
const _hoisted_3 = { class: "w-48 flex flex-row items-center" };
const _hoisted_4 = {
    class: "px-2 flex flex-row items-center space-x-3",
    style: { "width": "100px" }
};
const _hoisted_5 = { class: "text-sm text-gray-900 font-medium" };
import { useHistoryStore } from '@/store/history';
import { ReverseLeftIcon, ReverseRightIcon, XIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIDivider, UISpace, UITooltip } from '@gohighlevel/ghl-ui';
import { computed, inject } from 'vue';
import { applyHistory } from '@/compositions/useHistoryHelper';
import { getShapeNode } from '@/compositions/useStickerHistoryHelper';
import EmitterEvent from '@/events';
import { HistoryType } from '@/types/history';
import { Identifiers } from '@/types/identifiers';
import { Tools } from '@/types/tools';
import Konva from 'konva';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalHeaderV2',
    props: {
        loading: {
            type: Boolean,
            require: true,
        },
        stage: {
            type: Object,
            require: true,
        },
        group: {
            type: Object,
            require: true,
        },
        disableAction: {
            type: Boolean,
            require: true,
        },
    },
    emits: ['close', 'load-image'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const historyStore = useHistoryStore();
        const emitter = inject('emitter');
        const isUndoEnable = computed(() => historyStore.historyIndex !== -1);
        const isRedoEnable = computed(() => historyStore.history.length - 1 !== historyStore.historyIndex);
        function closeEditor() {
            emits('close');
        }
        function undo() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!isUndoEnable.value || props.loading || props.disableAction)
                    return;
                const history = historyStore.undo();
                if (history) {
                    yield processHistory(history.type, history.source, history.id, history.before);
                }
            });
        }
        function redo() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!isRedoEnable.value || props.loading || props.disableAction)
                    return;
                const history = historyStore.redo();
                if (history) {
                    yield processHistory(history.type, history.source, history.id, history.after);
                }
            });
        }
        function processHistory(type, source, id, history) {
            return __awaiter(this, void 0, void 0, function* () {
                switch (type) {
                    case HistoryType.REPLACE:
                        emits('load-image', history.blob);
                        break;
                    case HistoryType.ADD:
                        if (history) {
                            yield addOperation(id, source, history);
                        }
                        else {
                            removeOperation(id, source);
                        }
                        break;
                    case HistoryType.UPDATE:
                        updateOperation(id, source, history);
                        break;
                }
            });
        }
        function updateOperation(id, source, history) {
            const obj = props.group.find(`#${id}`)[0];
            if (obj) {
                applyHistory(obj, source, history);
                obj.draw();
                setToolsProperties(source, id, history);
            }
        }
        function removeOperation(id, source) {
            const obj = props.group.find(`#${id}`)[0];
            if (obj) {
                removeTransformer(source);
                obj.destroy();
                props.stage.batchDraw();
                setToolsProperties(source, id);
            }
        }
        function addOperation(id, source, history) {
            return __awaiter(this, void 0, void 0, function* () {
                let node, text, tag;
                switch (source) {
                    case Tools.TEXT:
                        history.id = id;
                        node = new Konva.Label({
                            x: history.x,
                            y: history.y,
                            width: history.width,
                            height: history.height,
                            rotation: history.rotation,
                            draggable: history.draggable,
                            id: history.id,
                            fill: history.fill,
                        });
                        tag = new Konva.Tag({
                            fill: history.backgroundColor,
                            id: history.id.replace('-label', '-tag'),
                        });
                        text = new Konva.Text({
                            text: history.text,
                            fontSize: history.fontSize,
                            fill: history.fill,
                            fontFamily: history.fontFamily,
                            align: history.align,
                            lineHeight: history.lineHeight,
                            verticalAlign: 'middle',
                            wrap: 'word',
                            padding: 5,
                            id: history.id.replace('-label', ''),
                        });
                        node.add(tag).add(text);
                        break;
                    case Tools.STICKERS:
                        history.id = id;
                        node = yield getShapeNode(history);
                        break;
                    case Tools.BRUSH:
                        history.id = id;
                        node = new Konva.Line(Object.assign({ id }, history));
                        break;
                }
                if (node) {
                    props.group.add(node);
                    setToolsProperties(source, id, history);
                }
            });
        }
        function removeTransformer(source) {
            let transformerId;
            switch (source) {
                case Tools.TEXT:
                    transformerId = Identifiers.TEXT_TRANSFORMER;
                    break;
                case Tools.STICKERS:
                    transformerId = Identifiers.STICKER_TRANSFORMER;
                    break;
            }
            const transformer = props.group.find(`#${transformerId}`)[0];
            if (transformer) {
                transformer.detach();
            }
        }
        function setToolsProperties(source, id, history) {
            var _a, _b;
            let historySet;
            let filterName = '';
            let customFilter = [];
            if (history) {
                switch (source) {
                    case Tools.ADJUSTMENTS:
                    case Tools.FILTERS:
                        customFilter = (_a = history.filters) === null || _a === void 0 ? void 0 : _a.filters.find((f) => { var _a; return (_a = f.name) === null || _a === void 0 ? void 0 : _a.includes('customFilter'); });
                        if (customFilter) {
                            filterName = customFilter.name.split('_')[1];
                        }
                        historySet = {
                            source: source,
                            filterValues: ((_b = history.filters) === null || _b === void 0 ? void 0 : _b.values) || [],
                            filterName,
                        };
                        break;
                    case Tools.TEXT:
                        historySet = {
                            id,
                            source: Tools.TEXT,
                        };
                        break;
                    case Tools.STICKERS:
                        historySet = {
                            id,
                            source: Tools.STICKERS,
                        };
                        break;
                }
            }
            const elementControls = document.getElementById('ghl-image-editor-element-control');
            elementControls.style.top = '0px';
            elementControls.style.left = '0px';
            elementControls.style.display = 'none';
            emitter.emit(EmitterEvent.IMAGE_EDITOR_HISTORY_SET, historySet);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(UISpace), {
                        justify: "space-between",
                        align: "center"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('common.title')), 1),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_unref(UITooltip), null, {
                                        trigger: _withCtx(() => [
                                            _createVNode(_unref(ReverseLeftIcon), {
                                                class: _normalizeClass([
                                                    _unref(isUndoEnable)
                                                        ? 'text-gray-700 cursor-pointer'
                                                        : 'text-gray-400 cursor-not-allowed',
                                                    "w-6 h-6"
                                                ]),
                                                onClick: undo
                                            }, null, 8, ["class"])
                                        ]),
                                        default: _withCtx(() => [
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.undo')), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(UITooltip), null, {
                                        trigger: _withCtx(() => [
                                            _createVNode(_unref(ReverseRightIcon), {
                                                class: _normalizeClass([
                                                    _unref(isRedoEnable)
                                                        ? 'text-gray-700 cursor-pointer'
                                                        : 'text-gray-400 cursor-not-allowed',
                                                    "w-6 h-6"
                                                ]),
                                                onClick: redo
                                            }, null, 8, ["class"])
                                        ]),
                                        default: _withCtx(() => [
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.redo')), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _createVNode(_unref(UIDivider), { vertical: true }),
                                _createElementVNode("div", {
                                    class: "flex justify-end cursor-pointer",
                                    style: { "width": "60px" },
                                    onClick: closeEditor
                                }, [
                                    _createVNode(_unref(XIcon), { class: "w-6 h-6 text-gray-900" })
                                ])
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('common.subtitle')), 1)
            ], 64));
        };
    }
});
